import React from 'react'
import Pg11 from '../../../myapp/services/add-money/Pg/Pg11.jsx'

function PG11Page() {
  return (
    <Pg11/>
  )
}

export default PG11Page